import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function ChangeOffert({ onSelect, onClose }) {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      // Pobieramy listę wszystkich dostępnych ofert
      const response = await axios.get('https://megamont.pl/api/offers');
      setOffers(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Błąd podczas ładowania ofert:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title fw-bold">Wybierz Ofertę do Wyświetlenia</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} aria-label="Close"></button>
          </div>

          <div className="modal-body p-0" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <table className="table table-hover m-0">
              <thead className="table-light sticky-top">
                <tr>
                  <th className="ps-4" style={{ width: '80px' }}>ID</th>
                  <th>Nazwa Oferty</th>
                  <th className="text-end pe-4">Akcja</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center py-5">
                      <div className="spinner-border text-primary" role="status"></div>
                      <div className="mt-2">Pobieranie ofert...</div>
                    </td>
                  </tr>
                ) : offers.length > 0 ? (
                  offers.map((offer) => (
                    <tr key={offer.id} style={{ cursor: 'pointer' }} onClick={() => onSelect(offer)}>
                      <td className="ps-4 text-muted">#{offer.id}</td>
                      <td className="fw-bold">{offer.name}</td>
                      <td className="text-end pe-4">
                        <button 
                          className="btn btn-sm btn-success px-4" 
                          onClick={(e) => {
                            e.stopPropagation(); 
                            onSelect(offer);
                          }}
                        >
                          Wybierz
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-5 text-muted">
                      Brak ofert w bazie danych. Dodaj je najpierw w panelu ofert.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="modal-footer bg-light">
            <button type="button" className="btn btn-secondary px-4" onClick={onClose}>Anuluj</button>
          </div>

        </div>
      </div>
    </div>
  );
}